Ext.define('SA.view.quickreport.QuickReportValueCellMenu', {
    alias: 'quickreport.value-cell-menu',
    extend: 'SA.view.quickreport.QuickReportCellMenu',

    getConfig(params) {
        var cfg = this.callParent(arguments),
            location = params.location,
            attribute = params.attribute;

        cfg.items.push(
            {
                xtype: 'component',
                cls: 'sa-quick-report-cell-menu-caption',
                html: this.getLocationCaptionHtml(location)
            }, {
                xtype: 'component',
                cls: 'sa-quick-report-cell-menu-caption',
                html: getAttributeCaptionHtml()
            }, {
                xtype: 'menu-create-map',
                attribute,
                location
            }, {
                xtype: 'menu-create-ranking',
                attribute,
                location
            }, {
                xtype: 'menu-create-bar-chart',
                attribute
            }
        );

        return cfg;

        function getAttributeCaptionHtml() {
            var attributeItem = SA.data.AttributesCache.get(attribute);

            return Ext.util.Format.htmlEncode(attributeItem.name + ', ' + attributeItem.year);
        }
    }
});